import {
  getLeoUuid,
  LeoUUID,
  getObject,
  getBoolean,
} from "@surya-digital/leo-ts-types";
import { SurveyViewName, SurveyViewNameDTO } from "./surveyViewName";

export interface SurveyDashboardViewDTO {
  surveyViewId: string;
  surveyViewName: SurveyViewNameDTO;
  isMasterView: boolean;
  isSPoCChangeGraphAllowed: boolean;
}

export class SurveyDashboardView {
  readonly isSurveyDashboardViewSurveyDashboardView: boolean = true;

  readonly surveyViewId: LeoUUID;
  readonly surveyViewName: SurveyViewName;
  readonly isMasterView: boolean;
  readonly isSPoCChangeGraphAllowed: boolean;


  constructor(
  surveyViewId: LeoUUID, 
  surveyViewName: SurveyViewName, 
  isMasterView: boolean, 
  isSPoCChangeGraphAllowed: boolean
  ) {
    this.surveyViewId = surveyViewId;
    this.surveyViewName = surveyViewName;
    this.isMasterView = isMasterView;
    this.isSPoCChangeGraphAllowed = isSPoCChangeGraphAllowed;
  }

  static fromDTO(dto: SurveyDashboardViewDTO): SurveyDashboardView {
    const surveyViewId = getLeoUuid(dto, "surveyViewId", InvalidSurveyDashboardViewSurveyViewIdError);
    const surveyViewName = SurveyViewName.fromDTO(getObject(dto, "surveyViewName", InvalidSurveyDashboardViewSurveyViewNameError));
    const isMasterView = getBoolean(dto, "isMasterView", InvalidSurveyDashboardViewIsMasterViewError);
    const isSPoCChangeGraphAllowed = getBoolean(dto, "isSPoCChangeGraphAllowed", InvalidSurveyDashboardViewIsSPoCChangeGraphAllowedError);
    return new SurveyDashboardView(
      surveyViewId,
      surveyViewName,
      isMasterView,
      isSPoCChangeGraphAllowed
    );
  }

  toDTO(): SurveyDashboardViewDTO {
    const dto: SurveyDashboardViewDTO = {
        surveyViewId: this.surveyViewId.toDTO(),
        surveyViewName: this.surveyViewName.toDTO(),
        isMasterView: this.isMasterView,
        isSPoCChangeGraphAllowed: this.isSPoCChangeGraphAllowed
    };
    return dto;
  }
  }

SurveyDashboardView.prototype.toString = function toString(): string {
  return `SurveyDashboardView(surveyViewId='${this.surveyViewId}',surveyViewName='${this.surveyViewName}',isMasterView='${this.isMasterView}',isSPoCChangeGraphAllowed='${this.isSPoCChangeGraphAllowed}')`;
};

export class InvalidSurveyDashboardViewError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDashboardViewError";
  }
}
export class InvalidSurveyDashboardViewSurveyViewIdError extends InvalidSurveyDashboardViewError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDashboardViewSurveyViewIdError";
  }
}

export class InvalidSurveyDashboardViewSurveyViewNameError extends InvalidSurveyDashboardViewError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDashboardViewSurveyViewNameError";
  }
}

export class InvalidSurveyDashboardViewIsMasterViewError extends InvalidSurveyDashboardViewError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDashboardViewIsMasterViewError";
  }
}

export class InvalidSurveyDashboardViewIsSPoCChangeGraphAllowedError extends InvalidSurveyDashboardViewError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyDashboardViewIsSPoCChangeGraphAllowedError";
  }
}
